import { BaseService } from "../../Base/BaseService";

export interface IFeedItem {
  id: number;
  title: string;
  description: string;
  imageUrl: string;

  masterId: number;
  masterName: string;

  serviceId: number;
  serviceName: string;
  price: number;
  minPrice?: number;

  categoryId: number;
  categoryName: string;
  categorySlug: string;

  createdAt: string;
  isFavorite?: boolean;

  masterAvatarUrl?: string | null;
  masterLocation?: string | null;

  distanceMeters?: number | null;
  distanceText?: string | null;
}

export interface IFeedResponse {
  posts: IFeedItem[];
  nextCursor: string | null;
  hasMore: boolean;
}

export interface ISimilarPostsResponse {
  posts: IFeedItem[];
  nextCursor: string | null;
  hasMore: boolean;
}

export interface IFeedCategory {
  id: number;
  name: string;
  slug: string;
  isVisibleInFeed: boolean;
  sortOrder: number;
}

export class FeedService extends BaseService {
  public static async GetFeed(limit: number = 20, cursor?: string | null, categoryId?: number | null): Promise<IFeedResponse> {
    const params = new URLSearchParams();

    params.set("limit", String(limit));

    if (cursor) {
      params.set("cursor", cursor);
    }

    if (categoryId) {
      params.set("categoryId", String(categoryId));
    }

    return this.get(this.BaseApiUrl + `/posts/feed?${params.toString()}`);
  }

  public static async GetFeedItem(id: number): Promise<IFeedItem> {
    return this.get(this.BaseApiUrl + `/posts/${id}`);
  }

  public static async GetCategories(): Promise<IFeedCategory[]> {
    return this.get(this.BaseApiUrl + `/categories/feed`);
  }

  public static async GetSimilarItems(id: number, limit: number = 20, cursor?: string | null): Promise<ISimilarPostsResponse> {
    const params = new URLSearchParams();

    params.set("limit", String(limit));

    if (cursor) {
      params.set("cursor", cursor);
    }

    return this.get(this.BaseApiUrl + `/posts/${id}/similar?${params.toString()}`);
  }
}
